import { ContactDetail, CustomAddress } from '@/explore/types';
import { formattedValues } from './contact-info.mjs';
import { EditValuesToBeSavedInterface, FeesInterface } from './editDetails.mjs';
import { ErrorInterface, LicenseHistoryInterface } from './licenseHistory.mjs';
import { DefaultShippingAddress } from './licensee.mjs';
import { Recognizer } from '@masterffl/ffl-search-component';

export interface ezCheckHistoryItem {
  status: string;
  created_at: string;
}

export interface callToGetEZCheckValidatorHistoryPayload {
  license_key: string;
}

export interface exploreState {
  isEzCheckHistoryInprogress: boolean;
  isEzCheckHistoryInCompleted: boolean;
  ezCheckHistory: Array<ezCheckHistoryItem>;
  isCreateDealerActionInprogress: boolean;
  isCreateDealerActionCompleted: boolean;
  isDealerOptOut: boolean;
  dealerOptOutValue: string;
  isLicenseHistoryCompleted: boolean;
  licenseHistoryItem: Array<LicenseHistoryInterface>;
  isLicenseHistoryInprogress: boolean;
  licenseByZipQueryParams: LicenseByZipParamsInterface;
  LicenseByZipDistance: string
  showDropdown: showDropdownEnum | null
  filterList: Array<string>,
  query: string[] | undefined;
  queryType: string | undefined;
  searchRecognizer: Recognizer | undefined;
  dealerActionsToBeSaved: Array<EditValuesToBeSavedInterface>;
  businessDetailsEdited: BusinessDetailsEdited;
  transferFeeEdited: FeesInterface;
  optinOptoutEdited: string;
  isSendingDealerProfileEditEmail: boolean;
  isDealerProfileEditEmailSended: boolean;
  isLicenseRemoved: boolean;
  contactDetailsEdit: null | Array<ContactDetail>;
  customAddressEdit: null | Array<CustomAddress>;
  emailErrorState: Array<ErrorInterface>;
  newContactDetailsError: Array<ErrorInterface>;
  contactDetailsError: Array<ErrorInterface>;
  isBlacklisted:boolean;
  defaultShippingAddressEdited: DefaultShippingAddress | null;
  isShootingRangeRevert:boolean;
  searchCount: number;
  isSearchingDealer: boolean;
  isSearchStarted: boolean;
  suggestedResult?: any;
  suggestedResultLoading?: boolean;
  refreshSerpEnrichmentLoading?: boolean;
  LicenseByState?: string[];
  bouncedEmailValidationError:string;
  savedFilterCollections: any[];
  savedFilterCollectionsLoading: boolean;
  selectedSavedFilterId: string | null;
  savedFilterSuccessEvent: { kind: 'save' | 'update' | 'delete'; name: string } | null;
}

export interface ezCheckHistoryResponse {
  historyList?: Array<ezCheckHistoryItem>;
}

export interface LicenseByZipParamsInterface {
  types?: string;
  min_rating_count?: string;
  min_review_count?: string;
  gun_type?: string;
  primary_gun_business?: boolean;
  include_opt_out_dealers?: boolean;
  open_on_weekends?: boolean;
  has_valid_certificate?: boolean;
  delivery_indicator?: string;
  delivery_indicator_commercial?: string;
  has_email_address?: boolean;
  descending?: Boolean;
  sortBy?: string;
}

export enum showDropdownEnum{
  filters,
  sortBy
}

export interface BusinessDetailsEdited {
  phones: formattedValues[] | null ;
  contacts: Array<string> | null;
  websites: Array<string> | null;
  emails: formattedValues[] | null;
}
